import { HeatMapPresenter } from '@/presentation/presenters/dashboard/heatMapPresenter'
import { HeatMapViewModel } from '@/presentation/viewmodels/dashboard/heatMapViewModel'

export function useHeatMapPresenter(presenter: HeatMapPresenter = new HeatMapPresenter(new HeatMapViewModel())) {
  return {
    userJudgeRecordList: presenter.userJudgeRecordList,
    heatMapXLabel: presenter.heatMapXLabel,
    heatMapSeries: presenter.heatMapSeries,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getUserJudgeRecord: presenter.getUserJudgeRecord,
    getHeatMapData: presenter.getHeatMapData
  }
}
